import React, { useEffect } from 'react';
import { StatusBar, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import i18n, { resolveLanguage } from './src/i18n';
import Navigation from './src/navigation';
import { DialogHost } from './src/components/Dialogs';
import TimerBar from './src/components/TimerBar';
import HolidayDecor from './src/components/HolidayDecor';
import ThemeLayer from './src/components/ThemeLayer';
import { telegram } from './src/platform/telegram';
import { startBilling, checkEntitlement } from './src/platform/iap';
import { startCloudSync } from './src/store/cloud';
import { useSettings } from './src/store/settings';
import { useAccount } from './src/store/account';
import { usePalette } from './src/theme';

export default function App() {
  const p = usePalette();
  const language = useSettings(s => s.language);
  const accountId = useAccount(s => s.user?.id);
  const accountStatus = useAccount(s => s.status);

  useEffect(() => telegram.ready(), []);
  useEffect(() => {
    if (accountStatus !== 'ready') return;
    let mounted = true;
    checkEntitlement().then(isSuper => {
      if (mounted && useSettings.getState().isSuper !== isSuper) useSettings.getState().set({ isSuper });
    }).catch(() => {});
    const stop = accountId ? startBilling() : () => {};
    return () => { mounted = false; stop(); };
  }, [accountId, accountStatus]);
  useEffect(() => {
    i18n.changeLanguage(resolveLanguage(language));
  }, [language]);
  // Billing follows the signed-in account; native and web both use verified server entitlements.
  useEffect(() => {
    useAccount.getState().init().catch(() => {});
    startCloudSync();
  }, []);

  return (
    <SafeAreaProvider>
      <StatusBar barStyle={p.scheme === 'dark' ? 'light-content' : 'dark-content'} />
      <View style={{ flex: 1, backgroundColor: p.background }}>
        <Navigation />
        <TimerBar bottomOffset={64} />
        <HolidayDecor />
        <DialogHost />
        <ThemeLayer />
      </View>
    </SafeAreaProvider>
  );
}
